import { type JsonObject, UserWithRole } from '@utilities-one/api-sdk';
import { merge } from 'lodash';

import { UserForGrid } from '@/entities/user/types';

interface ScopedPermissions {
  userProfile?: {
    companyScoped?: boolean;
  };
}

export const isPermissionsScoped = (item: UserForGrid): boolean => {
  const permissions = mergePermissions(item) as ScopedPermissions;
  return permissions?.userProfile?.companyScoped !== true;
};

/**
 * The user's effective permissions, and the bag the permission editors start from. Same rule as
 * the API's `mergePermissions`: a strict role ignores personal overrides, so the form must not show
 * them as live either — otherwise the editor would display grants the API never applies.
 */
export function mergePermissions(user: UserWithRole) {
  const rolePermissions = user.role?.permissions;
  const userPermissions = user.permissions;

  if (!rolePermissions || !userPermissions || user.role?.strict) return rolePermissions as JsonObject;

  return merge({}, rolePermissions, userPermissions) as JsonObject;
}
